import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SlokaTypeLogicService } from '../../logic/sloka-type.service';
import { SlokaTypeModel, SlokaBackendModel } from '../../interfaces/interfaces';
@Component({
  selector: 'table-cmp',
  templateUrl: './table.component.html',
})
export class TableComponent implements OnInit {
  @Input() isSlokaType: boolean = true;
  @Input() isUserList: boolean = false;
  @Input('table-data') tableData: any[] = [];
  @Input('page') page: number = 1;
  @Output('action') action = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}

  onDeleteClick(data: any) {
    this.action.emit({
      isAddSloka: false,
      isEdit: false,
      isDelete: true,
      isView: false,
      data: data,
    });
  }

  onEditClick(data: any) {
    this.action.emit({
      isAddSloka: false,
      isEdit: true,
      isDelete: false,
      isView: false,
      data: data,
    });
  }

  onViewClick(data: any) {
    this.action.emit({
      isAddSloka: false,
      isEdit: false,
      isDelete: false,
      isView: true,
      data: data,
    });
  }

  onAddSlokaClick(data: any) {
    this.action.emit({
      isAddSloka: true,
      isEdit: false,
      isDelete: false,
      isView: false,
      data: data,
    });
  }

  onVideoLinkClick(data: any) {
    this.openLink(data.videoLink);
  }

  onAudioLinkClick(data: any) {
    this.openLink(data.audioLink);
  }

  onPdfLinkClick(data: any) {
    this.openLink(data.pdfLink);
  }

  openLink(link: string) {
    if (link) {
      const win = window.open(link, '_blank');
      if (win != null) {
        win.focus();
      }
    }
  }
}
